<template>
  <div class="vx-row mb-5">
    <div class="vx-col w-full">
      <vx-card>
        <div class="vx-row">
          <!-- {{ avaliados }} -->
          <!-- {{ dados }} --> 
          <!-- {{ departments }} -->
          <!-- {{ departmentNames }} -->
          <!-- {{ departmentEmployee }} -->
          <!-- <div class="vx-col sm:w-1/2 w-full mb-2">
            <h5 class="mt-10">Departamento</h5>
            <select v-model="selectedDepartmentId" class="custom-select">
              <option
                v-for="department in uniqueDepartmentNames"
                :value="department.id"
              >
                {{ department.name }}
              </option>
            </select>
            <div v-if="selectedDepartmentId">
              <p>Id do departamento: {{ selectedDepartmentId }}</p>
            </div>
          </div> -->
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <h5 class="mt-10">Funcionário</h5>
            <select v-model="selectedEmployee" class="custom-select">
              <option
                v-for="employee in departmentEmployees"
                :value="employee.id"
                :key="employee.id"
              >
                {{ employee.name }}
              </option>
            </select>
          </div>
          <!-- <vs-button type="border" @click="goBack">Continuar</vs-button> -->
        </div>
      </vx-card>
      <br />
      <vx-card>
        <div
          class="vx-col w-full mb-2 flex justify-end"
          v-if="selectedEmployee"
        >
          <!-- <vs-button
            icon-pack="feather"
            icon="icon-plus"
            type="border"
            class="add-button"
          >
            <span class="button-text">Adicionar Critério</span>
          </vs-button> -->
        </div>

        <div class="vx-row" v-if="selectedEmployee">
          <div
            class="vx-col w-1/2"
            v-for="(grupo, index) in dados"
            :key="index"
          >
            <div>
              <h5>
                <b>{{ grupo.name }}</b>
              </h5>

              <ul>
                <li v-for="criterio in grupo.criterias" :key="criterio.id">
                  <input type="checkbox" v-model="criterio.checked" />
                  {{ criterio.name }}
                </li>
              </ul>
            </div>
          </div>
          &nbsp;&nbsp;
          <input
            type="checkbox"
            v-model="selectAll"
            @change="selectAllCriteria"
          />
          Marcar Todos

          <div class="vx-col w-full mb-2 text-right">
            <vs-button type="border" @click="goBack">Cancelar</vs-button>
            &nbsp;&nbsp;
            <vs-button @click="showSelectedCriteria">Continuar</vs-button>
          </div>
        </div>
      </vx-card>

      <br />
      <vx-card v-if="showQuestionario" title="Questionário">
        <div class="vx-row">
          <div
            class="criterio-item"
            v-for="(criterio, index) in criteriosSelecionados"
            :key="criterio.id"
          >
            <b>{{ criterio.name }}</b>
            <!-- <p>Valor do Range: {{ criterio.rangeValue }}</p>
            <p>Selected Descrição ID: {{ criterio.selectedDescricaoId }}</p> -->
            <ul>
              <li
                v-for="descricao in criterio.descriptions"
                :key="descricao.id"
                class="descricao-item"
              >
                <!-- {{
                  getPerformanceDescriptionId(
                    criterio.rangeValue,
                    criterio.performance_descriptions
                  )
                }} -->
                {{ descricao.description }} ( {{ descricao.lower_weight }} - {{ descricao.high_weight }} )
                <!-- {{ descricao.id }} -->
                <span v-if="criterio.selectedDescricaoId === descricao.id" class="gray-text">✅</span>
              </li>
            </ul>
            <b><p>Pontuação</p></b>
            <input
              type="range"
              min="0"
              max="20"
              v-model="criterio.rangeValue"
              style="width: 300px"
              @input="updatePerformanceDescriptionId(criterio)"
            />
            <!-- {{
              getPerformanceDescriptionId(
                criterio.rangeValue,
                criterio.performance_descriptions
              )
            }} -->
            <!-- {{ criterio.performanceDescriptionId }}  -->
            {{ criterio.rangeValue }}
            <!-- {{ criterio.selectedDescricaoId }} -->
          </div>
        </div>
        <div class="vx-col w-full mb-2 text-right">
          <vs-button @click="saveData">Submeter</vs-button>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import http from "../../../../../http-common";
import VxTimeline from "@/components/timeline/VxTimeline.vue";

export default {
  components: {
    vSelect,
    VxTimeline,
  },
  data() {
    return {
      criteriosSelecionados: [],
      critery: [],
      departments: [],
      selectedDescricaoId: null,
      showQuestionario: false,
      selectedDepartment: null,
      selectedDepartmentId: null,
      selectedEmployee: null,
      selectAll: false,
      avaliados: [],
      status: "Submitted",
      period_id: null,
      departmentId: null,
      dados: [],
      rangeValue: 0,
    };
  },

  mounted() {
    this.initialize();
    this.departmentId = this.$route.params.departmentId;
    this.period_id = this.$route.params.period_id;

  
    if (this.$route.params.departmentId) {
      this.selectedDepartmentId = this.$route.params.departmentId;
      this.departmentEmployees();
    }
  },
  computed: {
    departmentEmployees() {
      if (this.selectedDepartmentId) {
        const employeesInDepartment = this.departments.filter(
          (department) => department.department_id === this.selectedDepartmentId
        );

        return employeesInDepartment.map((employee) => ({
          id: employee.user_id,
          name: employee.user_name,
        }));
      } else {
        return [];
      }
    },
  },

  methods: {
    initialize() {
      this.getDepartament();
      this.getAvaliation();
      this.getData();
    },
    goBack() {
      window.history.back();
    },
   
    updatePerformanceDescriptionId(criterio) {
      const descriptionId = this.getPerformanceDescriptionId(
        criterio.rangeValue,
        criterio.performance_descriptions
      );

      if (descriptionId !== null) {
        this.$set(criterio, "selectedDescricaoId", descriptionId);
      }
    },
    getPerformanceDescriptionId(rangeValue, performanceDescriptions) {
      for (let description of performanceDescriptions) {
        if (
          rangeValue >= description.lower_weight &&
          rangeValue <= description.high_weight
        ) {
          return description.id; 
        }
      }
      return null; 
    },
    checkRange(rangeValue, descriptionId, performanceDescriptionId) {
      return performanceDescriptionId === descriptionId;
    },
    getData() {
      // this.$vs.loading({
      //   container: "#div-with-loading",
      //   scale: 1.0,
      //   type: "sound",
      // });
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      http
        .get("/performances/getPerformanceData", config)
        .then((result) => {
          this.$vs.loading.close("#div-with-loading > .con-vs-loading");
          this.dados = result.data;
        })
        .catch((error) => {
          error;

          if (error.response.status == 401) {
            this.$router.push("/").catch(() => {});
          }
        });
    },

    saveData() {
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };

      const data = {
        employee_id: this.selectedEmployee,
        assessment_period_id: this.period_id,
        criteria_id: [],
        weight: [],
        description_id: [],
      };

      this.criteriosSelecionados.forEach((criterio) => {
        data.criteria_id.push(criterio.id);
        data.weight.push(criterio.rangeValue);
        data.description_id.push(criterio.selectedDescricaoId);
      });

      console.log("Dados enviados para o backend:", data);

      http
        .post("/performances/weightPerformanceDescription", data, config)
        .then((success) => {
          success;
          (this.popupAdd = false), this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Adicionado com sucesso!",
            color: "success",
            position: "top-right",
          });
          this.$router.go(-1);
        })
        .catch((error) => {
          error;
          this.err = error.response.data;
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
        });
    },

    getAvaliation() {
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      http
        .get("/performances/weightPerformanceDescription", config)
        .then((result) => {
          this.$vs.loading.close("#div-with-loading > .con-vs-loading");
          this.avaliados = result.data;
        })
        .catch((error) => {
          error;
          this.$vs.loading.close("#div-with-loading > .con-vs-loading");
          if (error.response.status == 401) {
            this.$router.push("/").catch(() => {});
          }
        });
    },

    // showSelectedCriteria() {
    //   this.criteriosSelecionados = [];
    //   this.dados.forEach((grupo) => {
    //     grupo.criterias.forEach((criterio) => {
    //       if (criterio.checked) {
    //         this.criteriosSelecionados.push({
    //           ...criterio,
    //           rangeValue: 0,
    //           descriptions: criterio.performance_descriptions,
    //           selectedDescricaoId: null, // Adicione essa propriedade para armazenar o ID selecionado
    //         });
    //       }
    //     });
    //   });

    //   // Agora, você pode iterar sobre os critérios selecionados para encontrar o ID de cada descrição
    //   this.criteriosSelecionados.forEach((criterio) => {
    //     criterio.descriptions.forEach((descricao) => {
    //       if (descricao.selected) {
    //         criterio.selectedDescricaoId = descricao.id;
    //       }
    //     });
    //   });

    //   this.showQuestionario = true;
    // },
    showSelectedCriteria() {
      this.criteriosSelecionados = [];
      this.dados.forEach((grupo) => {
        grupo.criterias.forEach((criterio) => {
          if (criterio.checked) {
            criterio.rangeValue = 0;
            this.criteriosSelecionados.push({
              ...criterio,
              descriptions: criterio.performance_descriptions,
            });
          }
        });
      });
      this.criteriosSelecionados.forEach((criterio) => {
        criterio.checked = true;
      });
      this.showQuestionario = true;
    },

    getDepartament() {
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      http
        .get("/performances/departments", config)
        .then((result) => {
          this.$vs.loading.close("#div-with-loading > .con-vs-loading");
          // const departmentsArray = Object.values(result.data);
          // this.departments = departmentsArray;
          this.departments = result.data;
        })
        .catch((error) => {
          error;
          this.$vs.loading.close("#div-with-loading > .con-vs-loading");
          if (error.response.status == 401) {
            this.$router.push("/").catch(() => {});
          }
        });
    },

    selectAllCriteria() {
      this.dados.forEach((grupo) => {
        grupo.criterias.forEach((criterio) => {
          criterio.checked = this.selectAll;
        });
      });
    },
  },
};
</script>

<style>
.gray-text {
  color: #7367f0;
}

.descricao-item {
  margin-bottom: 10px;
}

.criterio-item {
  margin-bottom: 20px;
  border-bottom: 1px solid #ccc;
  width: 100%;
}
.group {
  margin-bottom: 15px;
}
.criterion {
  margin-left: 20px;
}
.custom-select {
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
}
.add-button {
  position: relative;
  width: 40px;
  transition: width 0.5s ease-in-out;
  white-space: nowrap;
}

.add-button:hover {
  width: 200px; /* Largura aumentada ao passar o mouse */
}

.button-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.5s, visibility 0.5s;
}

.add-button:hover .button-text {
  opacity: 1;
  visibility: visible;
}

.add-button:hover .vs-button--icon {
  opacity: 0;
  visibility: hidden;
}
</style>
